import React, { useState, useEffect } from "react";
import { Modal, Input, Switch, Select } from "antd";
import floppyDiskImg from "../../../../assets/img/floppy-disk.svg";
import Title from "./components/title.js";

function DefensiveModal({
  state,
  dispatch,
  close,
  update,
  item,
  cutomStat,
  play,
  handleUpdatePlay,
  updateInputGrade,
  updateGrade,
  handleExpandToggle
}) {
  const [modalWidth, setModalWidth] = useState(235);
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setModalWidth(200);
    } else {
      setModalWidth(235);
    }
  }, [window.innerWidth]);

  return (
    state.qbcompletion && (
      <div className="w-full flex justify-between font-inter text-[14px] text-[#0F1A24]">
        <div className="w-[49%] flex flex-col">
          <span className="mb-2">Label</span>
          <Input
            onChange={({ target: { value } }) =>
              handleUpdatePlay(play.id, { gn: value })
            }
            defaultValue={play.gn}
            size="large"
          />
        </div>
        <div className="w-[49%]">
          <button
            onClick={() => handleExpandToggle(item, "qbcompletion-modal")}
            className="flex items-center focus:outline-0 justify-center w-fit bg-[#1A91FF] text-[#ffffff] px-3 py-2 rounded-[4px]"
          >
            <img src={floppyDiskImg} className="w-6" />
            <span className="ml-2">Save and close</span>
          </button>
        </div>
      </div>
    )
  );
}

export default DefensiveModal;
